<script>

import NavBar from './NavBar.vue';
import LeftNavMenu from './LeftNavMenu.vue';
import CampaignsComponentUsb from './CampaignsComponentUsb.vue';

    export default {
    name: 'CampaignPageUsb',
    props: { titolo: String },
    //components: { NavBar, LeftNavMenu,LoginComponent }
    components: { NavBar, LeftNavMenu, CampaignsComponentUsb }
}
</script>

<template lang="html">

        <body>
            <NavBar />
           <LeftNavMenu />
            <CampaignsComponentUsb />
        </body>   
   
</template>
  
<style lang="css">

</style>